import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BearerInterceptor } from "./interceptors/bearer.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { HeaderInterceptor } from "./interceptors/headers.interceptor";
import { LoaderComponent } from "./loader/loader.component";
import { MaterialModule } from "./material.module";
import { LoaderService } from "./services/loader.service";
import { SharedModule } from "./shared/shared.module";
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NpsEffects } from "./services/nps/nps.effects";
import { npsReducer } from "./services/nps/nps.reducer";

@NgModule({
  declarations: [AppComponent, LoaderComponent, NotFoundComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ScrollingModule,
    StoreModule.forRoot({ nps: npsReducer }, {}),
    EffectsModule.forRoot([NpsEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),  // Importa il modulo di scrolling qui
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BearerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    LoaderService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
